// @flow
import React from 'react';
import { Helmet } from 'react-helmet';
/*::
type TranslationUrl = {|
  locale: string;
  url: string;
|}

type Props = {|
  // Sets the HTML lang, used for og:locale
  language: 'en' | 'ar';

  pageTitle: string;
  pageDescription: string;
  pageUrl: string;
  siteTitle: string;
  siteUrl: string;
  canonicalUrl: ?string;
  pageType: 'article' | 'website';

  // Used as preview image when sharing on social media
  socialImageUrl: string;

  // Optional: adds username when shared on Twitter
  twitterUsername: ?string;

  // Optional: indicates alternative translations of current page
  translationUrls?: TranslationUrl[],
  robotsContent: string;
  meta?: HTMLMetaElement[];
|}

*/

var SeoPure = function SeoPure(_ref
/*: Props */
) {
  var language = _ref.language,
      pageTitle = _ref.pageTitle,
      pageDescription = _ref.pageDescription,
      pageUrl = _ref.pageUrl,
      siteTitle = _ref.siteTitle,
      siteUrl = _ref.siteUrl,
      canonicalUrl = _ref.canonicalUrl,
      pageType = _ref.pageType,
      socialImageUrl = _ref.socialImageUrl,
      twitterUsername = _ref.twitterUsername,
      _ref$translationUrls = _ref.translationUrls,
      translationUrls = _ref$translationUrls === void 0 ? [] : _ref$translationUrls,
      _ref$robotsContent = _ref.robotsContent,
      robotsContent = _ref$robotsContent === void 0 ? 'noindex, nofollow, noodp, noydir' : _ref$robotsContent,
      _ref$meta = _ref.meta,
      meta = _ref$meta === void 0 ? [] : _ref$meta;
  return /*#__PURE__*/React.createElement(Helmet, {
    htmlAttributes: {
      lang: language
    },
    title: pageTitle,
    meta: [{
      name: 'robots',
      content: robotsContent
    }, {
      name: 'title',
      content: pageTitle
    }, {
      name: 'description',
      content: pageDescription
    }, {
      property: 'og:title',
      content: pageTitle
    }, {
      property: 'og:url',
      content: pageUrl
    }, {
      property: 'og:description',
      content: pageDescription
    }, {
      property: 'og:type',
      content: pageType
    }, {
      property: 'og:image',
      content: socialImageUrl
    }, {
      property: 'og:site_name',
      content: siteTitle
    }, {
      property: 'og:locale',
      content: language === 'en' ? 'en_US' : 'ar_AE'
    }, {
      property: 'og:locale:alternate',
      content: language === 'en' ? 'ar_AE' : 'en_US'
    }, {
      name: 'twitter:card',
      content: 'summary'
    }, {
      name: 'twitter:site',
      content: twitterUsername
    }, {
      name: 'twitter:title',
      content: pageTitle
    }, {
      name: 'twitter:creator',
      content: twitterUsername
    }, {
      name: 'twitter:url',
      content: pageUrl
    }, {
      name: 'twitter:description',
      content: pageDescription
    }, {
      name: 'twitter:image',
      content: socialImageUrl
    }, {
      itemProp: 'image',
      content: socialImageUrl
    }].concat(meta)
  }, Array.isArray(translationUrls) && translationUrls.map(function (translation) {
    return /*#__PURE__*/React.createElement("link", {
      rel: "alternate",
      href: "" + siteUrl + translation.url,
      hrefLang: translation.locale,
      key: translation.locale
    });
  }), /*#__PURE__*/React.createElement("link", {
    rel: "alternate",
    href: pageUrl,
    hrefLang: language,
    key: language
  }), /*#__PURE__*/React.createElement("link", {
    rel: "canonical",
    href: canonicalUrl || pageUrl,
    "data-test": "meta-canonical"
  }));
};

export default SeoPure;